export default __webpack_public_path__ + "static/media/logo.ba5406ff.png";